import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface RejectVDRFileUploadRequest {
    engagementId: number;
    fileId: number;
}

export const RejectVDRFileUpload = createAsyncThunk(
    'dataRoom/rejectFileUpload',
    async (
        { engagementId, fileId }: RejectVDRFileUploadRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/reject-upload`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not reject file upload at the moment.',
                    'error'
                );
                throw new Error('Failed to reject file upload');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while rejecting file upload.',
                'error'
            );
            throw error;
        }
    }
);

